import { RouteObject } from 'react-router-dom'
import { ROUTES } from '.'
import { Admin, TableEtapas, TableGroups, TablePerfiles, TableSectoresComerciales, TableUnidadesNegocio, TableUsers, ReporteDetalleSistemaGrupo, TableClienteTipo, TableClienteTipoLCTC, ConfigSectorSistemaGrupo, TableEtapaEnvioMail } from '../pages'
import ConfigRelaciones from '../pages/cruds/cliente-tipo/ConfigRelaciones'
import ConfigRelacionesLCTC from '../pages/cruds/cliente-tipo-lctc/ConfigRelacionesLCTC'
import ReportesPage from '../pages/cruds/reportes/ReportesPage'
import { SafetyRoute } from 'src/components/security'
import { AppSecObjects, SecurityComponents } from 'src/types/security'
import TablaEventos from '../pages/eventos/components/TablaEventos'

export const adminRouter: RouteObject[] = [
    {
        path: ROUTES.PANEL,
        element: (
            <SafetyRoute componentName={SecurityComponents.AppRutas} objectName={AppSecObjects.RutaPanelAdmin}>
                <Admin />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.USUARIOS}`,
        element: (
            <SafetyRoute componentName={SecurityComponents.AppRutas} objectName={AppSecObjects.RutaAdminUsuarios}>
                <TableUsers />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.GRUPOS}`,
        element: (
            <SafetyRoute componentName={SecurityComponents.AppRutas} objectName={AppSecObjects.RutaAdminGrupos}>
                <TableGroups />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.SECTORES_COMERCIALES}`,
        element: (
            <SafetyRoute
                componentName={SecurityComponents.AppRutas}
                objectName={AppSecObjects.RutaAdminSectoresComerciales}
            >
                <TableSectoresComerciales />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.ETAPAS}`,
        element: (
            <SafetyRoute componentName={SecurityComponents.AppRutas} objectName={AppSecObjects.RutaAdminEtapas}>
                <TableEtapas />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.PERFILES}`,
        element: (
            <SafetyRoute componentName={SecurityComponents.AppRutas} objectName={AppSecObjects.RutaAdminPerfiles}>
                <TablePerfiles />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.UNIDADES_NEGOCIO}`,
        element: (
            <SafetyRoute
                componentName={SecurityComponents.AppRutas}
                objectName={AppSecObjects.RutaAdminUnidadesNegocio}
            >
                <TableUnidadesNegocio />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.REPORTES}`,
        element: (
            <SafetyRoute
                componentName={SecurityComponents.AppRutas}
                objectName={AppSecObjects.RutaAdminReportes}
            >
                <ReportesPage />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.REPORTE_DETALLE_SISTEMA_GRUPO}`,
        element: (
            <SafetyRoute
                componentName={SecurityComponents.AppRutas}
                objectName={AppSecObjects.RutaAdminReporteDetalleSistemaGrupo}
            >
                <ReporteDetalleSistemaGrupo />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.CLIENTE_TIPO}`,
        element: (
            <SafetyRoute
                componentName={SecurityComponents.AppRutas}
                objectName={AppSecObjects.RutaAdminClienteTipo}
            >
                <TableClienteTipo />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.CLIENTE_TIPO_RELACIONES}`,
        element: (
            <SafetyRoute
                componentName={SecurityComponents.AppRutas}
                objectName={AppSecObjects.RutaAdminClienteTipoRelaciones}
            >
                <ConfigRelaciones />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.CLIENTE_TIPO_LCTC}`,
        element: (
            <SafetyRoute componentName={SecurityComponents.AppRutas} objectName={AppSecObjects.RutaAdminClienteTipoLCTC}>
                <TableClienteTipoLCTC />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.CLIENTE_TIPO_LCTC_RELACIONES}`,
        element: (
            <SafetyRoute componentName={SecurityComponents.AppRutas} objectName={AppSecObjects.RutaAdminClienteTipoLCTCRelaciones}>
                <ConfigRelacionesLCTC />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.SECTOR_SISTEMA_GRUPO}`,
        element: (
            <SafetyRoute componentName={SecurityComponents.AppRutas} objectName={AppSecObjects.RutaAdminSectorSistemaGrupo}>
                <ConfigSectorSistemaGrupo />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.ETAPA_ENVIO_MAIL}`,
        element: (
            <SafetyRoute componentName={SecurityComponents.AppRutas} objectName={AppSecObjects.RutaAdminEtapaEnvioMail}>
                <TableEtapaEnvioMail />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.EVENTOS}`,
        element: (
            <SafetyRoute componentName={SecurityComponents.AppRutas} objectName={AppSecObjects.RutaAdminEventos}>
                <TablaEventos />
            </SafetyRoute>
        )
    }
]
